<template>
    <PopoverRight ref="popoverContent" width="700px">
       <div class="popover-slider-bar tag-lib-box">
          <p class="tag-lib-title">动态取值标签库</p>
          <el-tabs v-model="condition.type" type="card" @tab-click="tabClick">
            <el-tab-pane label="通用标签" name="1"></el-tab-pane>
            <el-tab-pane label="楼盘标签" name="2">
                <!-- <p style="margin-bottom:15px;">在“楼盘展示内容”中会调取对应楼盘的数据；在其它位置（标题、关键词、正文）默认调取第一个插入楼盘的数据。</p> -->
            </el-tab-pane>
          </el-tabs>
          <el-table :data="tagDataList" border style="width: 100%;" v-loading="isLoading">
            <el-table-column prop="label_name" label="标签名称">
                <template  slot-scope="scope">
                    <div class="tagArea"  @click="copyLib(scope.row.label_name)">
                        <span>{{scope.row.label_name}}</span>
                        <span class="copy">复制</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="value_rule" label="取值规则"></el-table-column>
            <el-table-column prop="value_sample" label="取值示例"></el-table-column>
          </el-table>
          <template v-if="tagDataList.length > 0">
            <el-pagination
                background
                layout="total,prev, pager, next"
                :current-page="condition.page"
                :total="condition.total"
                :page-size="condition.per_page"
                @current-change="currentChange"
            ></el-pagination>
          </template>
          <div class="align-center bottom-box">
            <el-button @click="hideMenu">关闭</el-button>
          </div>
       </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import {getTrendsDynamicLabels} from '@/service/dynamicModel'

export default {
    components:{
        PopoverRight
    },
    data(){
        return {
            condition: {
                type: '1',
                per_page: 10,
                page: 1,
                total:0
            },
            tagDataList:[],
            isLoading:false,
        }
    },
    mounted(){
        this.initData();
    },
    methods:{
        openMenu(){
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        hideMenu(){
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
        },
        tabClick(tab, event){
            this.condition.page = 1;
            this.initData();
        },
        async initData(){
            this.isLoading = true;
            getTrendsDynamicLabels(this.condition).then((data) => {
                this.condition.total=data.total
                this.tagDataList = data.data
            })
            this.isLoading = false
        },
        currentChange(index) {
            this.condition.page = index;
            this.initData();
        },
        copyLib(lib = "") {
            let oInput = document.createElement("input");
            oInput.value = lib;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            this.$message({
                message: "复制成功",
                type: "success",
            });
            oInput.remove();
        },
    }
}
</script>
<style lang="less" scoped>
 .tag-lib-box{
     height: 100%;
 }
 .tag-lib-title{
    margin-bottom: 15px;
    padding-bottom: 10px;
    font-size: 20px;
    color: #000;
    font-weight: bold;
 }
 .bottom-box{
     margin-top: 20px;
 }
 .tagArea{
     width: 100%;
     height: 100%;
 }
 .copy{
     color:#409EFF;
     margin-left:20px;
     cursor: pointer;
     display: none;
 }
 .tagArea:hover .copy{
     display: inline-block;
 }
</style>